import type { CSSProperties } from 'react';
import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type SwapVertProps = IconComponentBaseProps;

export const SwapVert = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: SwapVertProps) => {
  const maskId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={maskId} style={maskStyle} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M6.10889 8.42947C5.96711 8.42947 5.84833 8.38152 5.75256 8.28564C5.65689 8.18986 5.60906 8.07113 5.60906 7.92947V3.57563L4.06422 5.12047C3.974 5.2128 3.86128 5.25897 3.72606 5.25897C3.59083 5.25897 3.4715 5.21113 3.36806 5.11547C3.26461 5.01113 3.21289 4.89186 3.21289 4.75764C3.21289 4.62352 3.26461 4.50475 3.36806 4.4013L5.68089 2.08847C5.74322 2.02602 5.80928 1.98202 5.87906 1.95647C5.94895 1.9308 6.02378 1.91797 6.10356 1.91797C6.18333 1.91797 6.25911 1.93086 6.33089 1.95664C6.40267 1.98252 6.46934 2.02647 6.53089 2.08847L8.86039 4.41797C8.9595 4.51708 9.00839 4.63202 9.00706 4.7628C9.00583 4.89358 8.9535 5.01113 8.85006 5.11547C8.74661 5.21113 8.6295 5.26069 8.49872 5.26413C8.36795 5.26747 8.25089 5.21747 8.14756 5.11413L6.60906 3.57563V7.9358C6.60906 8.07569 6.56111 8.19291 6.46522 8.28747C6.36933 8.38213 6.25056 8.42947 6.10889 8.42947ZM9.89656 14.0756C9.81678 14.0756 9.741 14.0627 9.66922 14.0368C9.59745 14.011 9.53078 13.9671 9.46922 13.9051L7.13972 11.5756C7.04061 11.4764 6.99172 11.3615 6.99306 11.2308C6.99428 11.1 7.04661 10.9825 7.15006 10.8781C7.2535 10.7825 7.37061 10.7329 7.50139 10.7295C7.63217 10.726 7.74922 10.776 7.85256 10.8795L9.39106 12.418V8.05763C9.39106 7.91786 9.439 7.80063 9.53489 7.70597C9.63078 7.61141 9.74956 7.56414 9.89122 7.56414C10.033 7.56414 10.1518 7.61202 10.2476 7.7078C10.3432 7.80369 10.3911 7.92247 10.3911 8.06414V12.418L11.9359 10.873C12.0261 10.7807 12.1388 10.7346 12.2741 10.7346C12.4093 10.7346 12.5286 10.7825 12.6321 10.8781C12.7355 10.9825 12.7872 11.1017 12.7872 11.2358C12.7872 11.37 12.7355 11.4889 12.6321 11.5923L10.3192 13.9051C10.2569 13.9675 10.1908 14.0115 10.1211 14.0371C10.0512 14.0628 9.97633 14.0756 9.89656 14.0756Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

const maskStyle: CSSProperties = { maskType: 'alpha' };
